import React from 'react';
import './subscription.css';
import { useHistory } from "react-router-dom";
import ContextMenu from "../ContextMenu/ContextMenu";
import { useSelector, useDispatch } from "react-redux";
import {
    contextAction, dropdownAction,
    setExtendSubscriptionFormAction,
    repayMoneyFormAction,
    searchAction,
    subscriptionCalendarAction,
    subscriptionFormAction
} from "../../redux/rootReducer";
import {
    activationSubscriptionSagaAction,
    copySubscriptionSagaAction,
    deactivateSubscriptionSagaAction,
    freezeSubscriptionSagaAction,
    getFamilyListSagaAction,
    getWorkoutsFromCertainSubscriptionSagaAction,
    removeSubscriptionSagaAction
} from "../../redux/sagaActions";
import { addRecordThunk } from "../../redux/thunks/addRecordThunk";
import Tippy from '@tippyjs/react';

const Subscription = ({ data }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const context = useSelector(state => state.context);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);

    const menu = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(subscriptionFormAction({
                    open: true,
                    title: `Абонемент № ${ data.id }`,
                    id: data.id,
                    user: { id: data.user.id, name: data.user.name },
                    users: [],
                    userInput: '',
                    times: data.times,
                    type: data.type,
                    coach: data.coach,
                    time_constraint: data.time_constraint,
                    note: data.note,
                    unlim: data.unlim,
                    expire_date: data.expire_date,
                    activation_date: data.activation_date,
                    old_cost: data.cost,
                    payment: [],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: data.cost
                }));
            }
        },
        {
            id: '2',
            caption: 'Списать тренировку',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Открываем календарь абонемента
                dispatch(subscriptionCalendarAction({
                    open: true,
                    subscription_id: data.id
                }));
            }
        },
        {
            id: '3',
            caption: 'Заморозка абонемента',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));

                if (data.freezed === '1') {
                    if (window.confirm('Вы действительно хотите снять заморозку?')) {
                        dispatch(freezeSubscriptionSagaAction({
                            subscription_id: data?.id
                        }));
                    }
                }
                else {
                    if (window.confirm('Вы действительно хотите заморозить абонемент?')) {
                        dispatch(freezeSubscriptionSagaAction({
                            subscription_id: data?.id
                        }));
                    }
                }
            }
        },
        {
            id: '4',
            caption: 'Семейный абонемент',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Запрашиваем список пользователей семейного абонемента
                dispatch(getFamilyListSagaAction({ subscription_id: data.id }));
            },
        },
        {
            id: '5',
            caption: 'Продлить срок действия',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(setExtendSubscriptionFormAction({
                    open: true,
                    subscription_id: data.id,
                    expire_date: data.expire_date
                }));
            }
        },
        {
            id: '6',
            caption: 'Создать копию',
            handler: () => {

                if (window.confirm('Вы действительно хотите скопировать абонемент?')) {
                    dispatch(copySubscriptionSagaAction({ subscription_id: data.id }));
                }
                dispatch(contextAction(false));
            }
        },
        {
            id: '7',
            caption: 'Деактивировать абонемент',
            handler: () => {
                if (!window.confirm('Вы действительно хотите деактивировать абонемент?')) return;

                dispatch(deactivateSubscriptionSagaAction({ subscription_id: data.id }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '8',
            caption: 'Возврат средств',
            handler: () => {
                dispatch(repayMoneyFormAction({
                    open: true,
                    subscription_id: data.id,
                    sum: '',
                    payment_method: { id: '', name: '' }
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '9',
            caption: 'Удалить абонемент',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить абонемент?')) {
                    dispatch(removeSubscriptionSagaAction({ id: data.id }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    const menuNotActivation = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(subscriptionFormAction({
                    open: true,
                    title: `Абонемент № ${ data.id }`,
                    id: data.id,
                    user: { id: data.user.id, name: data.user.name },
                    users: [],
                    userInput: '',
                    times: data.times,
                    coach: data.coach,
                    type: data.type,
                    time_constraint: data.time_constraint,
                    note: data.note,
                    unlim: data.unlim,
                    expire_date: data.expire_date,
                    activation_date: data.activation_date,
                    old_cost: data.cost,
                    payment: [],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: data.cost
                }));
            }
        },
        {
            id: '2',
            caption: 'Активировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));

                if (window.confirm('Вы действительно хотите активировать абонемент?')) {
                    dispatch(activationSubscriptionSagaAction({ subscription_id: data?.id }));
                }
            }
        },
        {
            id: '3',
            caption: 'Семейный абонемент',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Запрашиваем список пользователей семейного абонемента
                dispatch(getFamilyListSagaAction({ subscription_id: data.id }));
            },
        },
        {
            id: '4',
            caption: 'Возврат средств',
            handler: () => {
                dispatch(repayMoneyFormAction({
                    open: true,
                    subscription_id: data.id,
                    sum: '',
                    payment_method: { id: '', name: '' }
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '5',
            caption: 'Удалить абонемент',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить абонемент?')) {
                    dispatch(removeSubscriptionSagaAction({ id: data.id }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    return (
        <div className="table__row table__row--hover subscription__item"
            style={{ backgroundColor: data.color }}
            onClick={ event => {

                if (!event.target.closest('.context')) {
                    dispatch(getWorkoutsFromCertainSubscriptionSagaAction({ subscription_id: data.id }));
                }
            } }
        >
            <div className="dropdown" style={{ position: 'absolute', width: '150px', right: '28px', marginTop: '21px' }}>
                <div className={ `dropdown__items ${ dropdown === 'workout_type' + data.id ? 'dropdown__items--open' : '' }` }>
                    {
                        subscription_types.map(elem => {
                            return (
                                <div className="dropdown__item"
                                     key={ elem.id }
                                     onClick={ event => {
                                        event.preventDefault();
                                        event.stopPropagation();

                                         dispatch(addRecordThunk({
                                             subscription_id: data.id,
                                             date: 'today',
                                             workout_type: elem.id
                                         }));

                                         dispatch(dropdownAction(null));
                                     } }
                                >{ elem.name }</div>
                            );
                        })
                    }
                </div>
            </div>
            <ContextMenu data={{
                open: data.id === context,
                style: { right: 28 },
                menu: data.activation_date !== '' && data.expire_date ? menu : menuNotActivation
            }}/>
            {
                data.family || data.note
                    ?
                    <Tippy content={ `${ data.family ? 'Семейный абонемент \n' : '' } ${ data.note }` }>
                        <div className="subscription__info"/>
                    </Tippy>
                    : false
            }
            <div className="table__cell table__cell--left">
                {
                    data.freezed === '1'
                        ? <Tippy content={ data.freezed_dates }>
                            <div className="subscription__freezed"/>
                        </Tippy>
                        : false }
                <div
                    className="subscription__name"
                    onClick={ event => {
                        if (!data.user?.id) return;

                        // Предотвращаем стандартное поведение
                        event.preventDefault();
                        event.stopPropagation();
                        // Очищаем поиск
                        dispatch(searchAction(''));
                        // Переходим в карточку клиента
                        history.push('/fitness/users/' + data.user?.id);
                    } }
                >
                    { data.user.name }
                    {
                        data.user.name &&
                        <Tippy content={ 'Открыть в новой вкладке' }>
                            <div className="user__tab"
                                 onClick={ event => {
                                     event.preventDefault();
                                     event.stopPropagation();

                                     window.open('/fitness/users/' + data.user?.id, '_blank', 'noopener,noreferrer');
                                 } }
                            />
                        </Tippy>
                    }
                </div>
            </div>
            <div className="table__cell">{ `${ data.workouts_done } / ${ data.times }` }</div>
            <div className="table__cell">{ data.buy_date }</div>
            <div
                className={ `table__cell ${ data.activation_date === '' ? 'table__cell--inactive' : '' }`}
            >{ data.activation_date ? new Date(data.activation_date).toLocaleDateString() : 'Не активирован' }</div>
            <div className="table__cell">{ data.expire_date ? new Date(data.expire_date).toLocaleDateString('ru-Ru') : '' }</div>
            <div className="table__cell">{ data.type.name }</div>
            <div className="table__cell">{ data.coach.name }</div>
            <div className="table__cell">{ data.time_constraint.name }</div>
            <div className="table__cell">{ data.cost }</div>
            <div className="table__cell">{ `${ data.freeze_times }/${ data.freeze_days }` }</div>
            <div className="table__cell">
                <div className="subscription__record">
                    <div className="subscription__record-now"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             dispatch(addRecordThunk({
                                 subscription_id: data.id,
                                 date: 'today'
                             }));
                         } }
                    >Списать</div>
                    <div className="subscription__record-type"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             dispatch(dropdownAction('workout_type' + data.id));
                         } }
                    />
                </div>
            </div>
            <i className="menu__button" onClick={ event => {
                event.preventDefault();
                event.stopPropagation();
                dispatch(contextAction(data.id));
            } }/>
        </div>
    );
};

export default Subscription;